import packageJson from '../../package.json';

export interface VersionInfo {
  version: string;
  buildDate: string;
  commit: string;
  environment: string;
}

// Build timestamp and commit hash are injected at build time by Vite
// Falls back to current time and 'dev' in development
const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIMESTAMP || new Date().toISOString();
const GIT_COMMIT_HASH = import.meta.env.VITE_GIT_COMMIT_HASH || 'dev';

/**
 * Get application version information
 * @returns Version info object with version, build date, and environment
 */
export function getVersionInfo(): VersionInfo {
  const buildDateObj = new Date(BUILD_TIMESTAMP);
  const buildDate = buildDateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const environment = import.meta.env.MODE || 'development';

  return {
    version: packageJson.version,
    buildDate,
    commit: GIT_COMMIT_HASH,
    environment,
  };
}

/**
 * Format version info as a description string
 * @returns Formatted version string for display
 */
export function formatVersionDescription(): string {
  const info = getVersionInfo();
  return `Version: ${info.version} • Build: ${info.buildDate} • Commit: ${info.commit} • Environment: ${info.environment}`;
}

